import fetch from 'unfetch';
import useSWRInfinite from 'swr/infinite';

const fetcher = (...args) => fetch(...args).then((res) => res.json());
const urlifyArray = (str) => encodeURIComponent(JSON.stringify(str));
const urlify = (str) => encodeURIComponent(str);

const PAGE_SIZE = 6;

export default function usePages({
  term = '', categories = [], sortOrder = 'title_asc', language = 'fi',
}) {
  const {
    data, error, size, setSize, isValidating,
  } = useSWRInfinite((index, previousData) => {
    // Last page.
    if (previousData && previousData.pages === index) { return null; }

    return `/wp-json/odl/v1/contact-search/?lang=${urlify(language)}&term=${urlify(term)}&sort=${urlify(sortOrder)}&categories=${urlifyArray(categories)}&per_page=${PAGE_SIZE}&page=${index + 1}`;
  }, fetcher);

  const isLoadingInitialData = !data && !error;

  return {
    page: data,
    size,
    setSize,
    isValidating,
    isLoadingInitialData,
    isError: error,
  };
}
